import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../Auth/useUser";

const PrivateRoute = ({ children }) => {
  const user = useUser();

  // If user is null (no token), redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has allowed role
  const allowedRoles = ["user", "admin", "caissier", "serveur"];
  if (allowedRoles.includes(user.result.role)) {
    return children;
  }

  // If user exists but role doesn't match, redirect to login
  return <Navigate to="/login" replace />;
};

export default PrivateRoute;
